<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader },
  data () {
    return {
      usePage: true
    }
  },
  methods: {
    getData (form) {
      this.loading = true
      this.$api
        .finPaymentNoInvoiceListApi({ ...form, ...this.page })
        .then(res => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage ({ pageType, data = {} }) {
      const { amzFtyOutboundCode = '', amzFtyOutboundNo = '' } = data
      let params = { pageType }
      let query = {}
      if (amzFtyOutboundCode) params = { ...params, amzFtyOutboundCode }
      if (amzFtyOutboundNo) query = { ...query, amzFtyOutboundNo }
      this.$router.push({
        name: 'ecom-awsBiz-ftyOutbound-detail',
        params,
        query
      })
    }
  }
}
</script>
